<div class="flip-block-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
	<div fxLayout="row" class="title" fxLayoutAlign="start center" fxLayoutGap="5px">
		<ng-container *ngIf="data?.icon || data?.svgIcon">
			<mat-icon *ngIf="data?.icon || data?.svgIcon" [svgIcon]="data?.svgIcon">
				{{data?.icon}}
			</mat-icon>
		</ng-container>
		<ng-container *ngIf="data?.title">
			<div class="flipcard-caption">
				{{data?.name}}
			</div>
		</ng-container>
	</div>
	<div fxLayoutAlign="start stretch" fxFlex="1 0">
		<ng-content select="content-area"></ng-content>
	</div>
	<div fxLayout="row" fxLayoutAlign="space-between center">
		<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
			<ng-container *ngIf="data?.dateCaption && data?.date">
				<ng-container *ngIf="data?.dateCaption">
					<span class="sub-caption-3">
						{{data?.dateCaption}}
					</span>
				</ng-container>
				<ng-container *ngIf="data?.dateCaption && data?.date">
					<span class="sub-caption-3">:</span>
				</ng-container>
				<ng-container *ngIf="data?.date">
					<span class="sub-info">
						{{data?.date}}
					</span>
				</ng-container>
			</ng-container>
		</div>

		<div fxLayoutAlign="end end">
			<ng-container *ngIf="data?.status">
				<div class="sub-txt-patch flip-status">
					{{data?.status}}
				</div>
			</ng-container>
		</div>
	</div>
</div>
